import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import useTripStore from "@/stores/tripBuilder/useTrip";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { LockIcon } from "lucide-react";

const PermissionDialog = () => {
  const {
    isPermissionDialogOpen,
    setPermissionDialogOpen,
    requestAdminAccess,
  } = useTripStore();

  return (
    <Dialog
      open={isPermissionDialogOpen}
      onOpenChange={setPermissionDialogOpen}
    >
      <DialogContent className="sm:max-w-[425px] p-4 sm:rounded-2xl">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div className="flex flex-col items-start space-y-2">
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-medium text-indigo-800">
                Admin Access Needed
              </h1>
            </div>
            <h3 className="text-sm font-light text-neutral-700">
              You can only view this trip
            </h3>
          </div>

          <div className="flex flex-col gap-3 mt-8 sm:flex-row sm:justify-end sm:gap-4">
            <Button
              variant="outline"
              onClick={() => setPermissionDialogOpen(false)}
              className={cn(
                "flex-1 sm:flex-initial rounded-full",
                "border-indigo-300 text-indigo-700 hover:bg-indigo-100",
                "transition-colors duration-200"
              )}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                requestAdminAccess();
                setPermissionDialogOpen(false);
              }}
              className={cn(
                "flex-1 sm:flex-initial rounded-full",
                "bg-indigo-600 hover:bg-indigo-700",
                "text-white transition-colors duration-200",
                "flex items-center gap-2"
              )}
            >
              <LockIcon className="w-4 h-4" />
              Request Access
            </Button>
          </div>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
};

export default PermissionDialog;
